exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n* DEFINE VARIABLES\n*/\n.isLoading {\n  display: block;\n  text-align: center;\n  color: #606060;\n}\n.noDisplay {\n  display: none;\n}\n.event-row-wrapper {\n  margin: 8px 0px;\n}\n.icon-size {\n  width: 100px;\n  height: 100px;\n}\n.plan-and-approve-container .table-event-container {\n  background-color: #f5f5f5;\n  overflow: auto;\n}\n.plan-and-approve-container .table-event-container .fix-position-top {\n  -webkit-transition: all 0.7s;\n  transition: all 0.7s;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6581373e","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/manager/PlanAndApprove.vue
// module id = 1759
// module chunks = 1